import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=2c542b9d"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=2c542b9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports